import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";
import { API_BASE_CRM_URL, API_BASE_URL } from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import "../../../Assets/popup.css";
import PDFIMG from "../../Config/pdf.svg";
import EXCELIMG from "../../Config/excel.svg";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../../Config/loading.css";
import { Link, useNavigate } from "react-router-dom";
import { useLabelContext } from "../../../Context";
import Dashboard from "../Dashboard/Dashboard";
import { Footer } from "../footer/footer";

export default function Categories() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [categoriesData, setCategoriesData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [locationViewObj, setLocationViewObj] = useState([]);
  const [locationEditObj, setLocationEditObj] = useState([]);
  const [userDataSession, setUserDataSession] = useState({});
  const { setID } = useLabelContext();

  useEffect(() => {
    const userDataString =
      sessionStorage.getItem("MisUserDetails") ||
      localStorage.getItem("MisUserDetails");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  console.log(userDataSession);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}MobileSVC/getCategories?OrgId=${userDataSession.OrgId}`
        );
        const data = await response.json();
        console.log(data);
        if (data.Status) {
          setCategoriesData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setCategoriesData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    // Only fetch data if OrgId is available
    if (userDataSession && userDataSession.OrgId) {
      fetchData();
    }
  }, [userDataSession.OrgId]);

  const handleReload = () => {
    window.location.reload();
  };

  const showLocationViewModal = (obj) => {
    setLocationViewObj(obj);
  };

  const showLocationEditModal = (obj) => {
    setLocationEditObj(obj);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredItems = useMemo(() => {
    const results = categoriesData.filter(
      (item) =>
        item.Name && item.Name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setCurrentPage(1);

    return results;
  }, [categoriesData, searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleExcelDownload = () => {
    if (categoriesData.length === 0) {
      return;
    }
    const wb = XLSX.utils.book_new();

    const wsData = categoriesData.map((item) => ({
      Name: item.expense_name,
      Date: formatDate(item.date),
      Category: item.category_name,
      Amount: item.amount,
      Customer: item.cus_name,
      Project: item.proj_name,
      "Payment Type": item.paymentmode,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "CustoemrsData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "CustoemrsData.xlsx");
  };

  const handlePDFDownload = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Expenses Data",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = [
      "Name",
      "Date",
      "Category",
      "Amount",
      "Customer",
      "Project",
      "Payment Type",
    ];
    tableData.push(headers);

    // Add rows
    categoriesData.forEach((item) => {
      const row = [];
      row.push(
        item.expense_name,
        formatDate(item.date),
        item.category_name,
        item.amount,
        item.cus_name,
        item.proj_name,
        item.paymentmode
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("expensesData.pdf");
  };

  return (
    <Base>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="page-title me-2">
            <h4>Categories</h4>
            <h6>Manage Categories</h6>
          </div>
          <div className="search-bar mb-3 ">
            <div className="input-group">
              <input
                type="text"
                name="search..........."
                placeholder="Search..."
                className="form-control"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="card-container mb-0" style={{ marginTop: "-20px" }}>
        {loading ? (
          <div className="text-center my-3">
            <div className="containers m-auto d-flex justify-content-center align-items-center">
              <div className="dot bg-primary"></div>
              <div className="dot bg-secondary"></div>
              <div className="dot bg-success"></div>
              <div className="dot bg-danger"></div>
              <div className="dot bg-warning"></div>
              <div className="dot bg-info"></div>
            </div>
            <p>Loading...</p>
          </div>
        ) : (
          <div className="row">
            {currentItems &&
              currentItems.map((item, index) => (
                <div
                  key={index}
                  className="col-md-6"
                  style={{ marginTop: "-20px" }}
                >
                  <div
                    className="store-card card shadow-sm my-3"
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      padding: "1px",
                    }}
                  >
                    <div className="card-body">
                      {/* <h5 className="card-title d-flex align-items-center mb-3" style={{ marginRight: '5px', color: '#007bff' }}>
                                            {item.Name}
                                        </h5> */}
                      <div className="card-details">
                        <div
                          className="row"
                          style={{ color: "#6c757d", marginTop: "10px" }}
                        >
                          <div className="col-6">
                            <span>
                              <strong>
                                <i
                                  className="fa-solid fa-shop me-2"
                                  style={{ color: "#007bff" }}
                                ></i>
                                Name:
                              </strong>{" "}
                              {item.Name}
                            </span>
                          </div>
                          <div className="col-6">
                            <span>
                              <strong>
                                <i
                                  className="fa-solid fa-indent me-2"
                                  style={{ color: "#007bff" }}
                                ></i>
                                code:
                              </strong>{" "}
                              {item.Code}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={categoriesData.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      </div>
      <br />
      <br />
      <br />
      <Footer></Footer>
    </Base>
  );
}
